/**
 * Quiz analytics: pushes events to the GTM dataLayer (and dispatches them as
 * DOM events) so drop-off can be measured without sending anything to
 * HubSpot until the visitor submits the lead form.
 *
 * Every push carries the full set of quiz_* keys, with null for the ones that
 * don't apply, so values from an earlier event never carry over in GTM's
 * data model.
 *
 * Events:
 * - em_quiz_view            First question shown (modal opened / inline scrolled into view).
 * - em_quiz_answer          A question answered for the first time.
 * - em_quiz_answer_change   A question re-answered with "Change answer".
 * - em_quiz_complete        All questions answered (once per run).
 * - em_quiz_result_change   The result changed after completion.
 * - em_quiz_lead_submit     The lead form was submitted.
 * - em_quiz_restart         "Start over".
 * - em_quiz_open            Modal opened.
 * - em_quiz_close           Modal closed (with how far the visitor got).
 *
 * @package ppd
 * @since   1.0.27
 */

const KEYS = [
	'quiz_id',
	'quiz_name',
	'quiz_session',
	'quiz_display',
	'quiz_total',
	'quiz_answered',
	'quiz_step',
	'quiz_question',
	'quiz_answer',
	'quiz_answer_category',
	'quiz_previous_answer',
	'quiz_result',
	'quiz_previous_result',
	'quiz_scores',
];

/**
 * @param {HTMLElement} root   Quiz element; receives an "em-quiz:track" event.
 * @param {string}      event  Event name, e.g. "em_quiz_answer".
 * @param {Object}      params quiz_* values.
 */
export default function track(root, event, params) {
	const data = { event };
	KEYS.forEach((key) => {
		data[key] = params[key] === undefined ? null : params[key];
	});

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(data);
	root.dispatchEvent(new CustomEvent('em-quiz:track', { bubbles: true, detail: data }));
}
